import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '../../../icons/check-circle.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Tooltip from '@material-ui/core/Tooltip';
import './ButtonInput.scss';
import InfoIcon from '@material-ui/icons/Info';

export default function ButtonInput(props) {
    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow button-input ${props.value ? 'active ' : 'inactive '} ${props.isProfile ? 'mt-2' : 'mt-4'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        >
            <span>
                <SvgIcon fontSize="large" component={props.icon} className={props.infoText ? 'icons mr-0' : 'icons'} />
                {props.infoText &&
                    <Tooltip title={props.infoText} className='float-right m-0'>
                        <InfoIcon color="action"></InfoIcon>
                    </Tooltip>
                }
                <h2 className="title">{props.title}</h2>
                <p className="subtitle">{props.subtitle}</p>
                {
                    props.value ?
                        <SvgIcon component={CheckCircleIcon} color="primary" name={props.productName} className="check" /> :
                        <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck" />
                }
            </span>
        </Button>
    );
}

ButtonInput.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/ButtonInput.js